export default {
	setSpecialists(state, specialists) {
		state.specialists = specialists
	},
}
